import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  List,
  ListItemText,
  Stack,
  ListItem,
  ListItemIcon,
  ListItemButton,
  Box,
} from "@mui/material";
import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import TipsAndUpdatesOutlinedIcon from "@mui/icons-material/TipsAndUpdatesOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import CrisisAlertOutlinedIcon from "@mui/icons-material/CrisisAlertOutlined";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import SettingsSuggestOutlined from "@mui/icons-material/SettingsSuggestOutlined";
import DonutSmallIcon from '@mui/icons-material/DonutSmall';
import BallotOutlinedIcon from "@mui/icons-material/BallotOutlined";
import { theme } from "../../../Theme";
import CollapsibleList from "./CollapsibleList";
import { useDispatch } from "react-redux";
import { setSelectedFilter } from "../../../Redux/filterSlice/filterSlice"; // 🆕 Import Redux action
import { setCurrentChartType } from "../../../Redux/chartSlice/chartSlice"; // ✅ Reset Chart Type
import {
  setAllMarketSelected,
} from "../../../Redux/handleAllMarket/handleAllMarket";
import smartbot1Image from "src/Assets/smartbot1.png";
import smartbot2Image from "src/Assets/smartbot2.png";


export function NestedList({ open, setTitle }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const role = localStorage.getItem("role");
  const isFreeTrial = role === "free_trial";

  const [active, setActive] = React.useState(
    () => location.pathname.replace(/^\//, "").split("/")[0] || "dashboard"
  );

  React.useEffect(() => {
    const pathSegment = location.pathname.replace(/^\//, "").split("/")[0] || "dashboard";
    setActive(pathSegment);
    localStorage.setItem("active", pathSegment);
  }, [location.pathname]);

  const handleClick = (link, title) => {
    setActive(link.split("/")[0]);
    if (setTitle) setTitle(title);
    localStorage.setItem("active", link.split("/")[0]);
    localStorage.setItem("pageTitle", title);
    navigate(`/${link}`);
  };

  React.useEffect(() => {
    localStorage.setItem("active", active);
  }, [active]);
  const handleLogout = () => {
    // Clear local storage
    localStorage.removeItem("userId");
    localStorage.removeItem("projectId");
    localStorage.removeItem("page");
    localStorage.removeItem("name");
    dispatch(setSelectedFilter([])); // ✅ Reset selected filters in Redux
    dispatch(setCurrentChartType(null)); // ✅ Reset chart type selection in Redux
    dispatch(setAllMarketSelected(false)); // Toggle between true/false
    window.location.href = "/login";
  };
  const MarketOverview = [
    {
      subPath: "dashboard",
      icon: <PieChartOutlineOutlinedIcon />,
      text: "Performance",
      onClick: handleClick,
      activeCondition: "dashboard",
      active,
    },
    {
      subPath: "gaps-solution",
      icon: <TipsAndUpdatesOutlinedIcon />,
      text: "Diagnostics Analysis",
      onClick: handleClick,
      activeCondition: "gaps-solution",
      active,
    },
    // { subPath: 'market-dynamics', icon: <EqualizerOutlinedIcon />, text: 'Market Dynamics', onClick: handleClick,activeCondition:"market-dynamics", active },
  ];
  const StrategyCreation = [
    {
      subPath: "pricing-architecture",
      icon: <ShoppingCartOutlinedIcon />,
      text: "Pricing",
      onClick: handleClick,
      activeCondition: "pricing-architecture",
      active,
      // disabled: isFreeTrial,
      disabled: true,
    },
    {
      subPath: "promotion-visibility",
      icon: <ShoppingBagOutlinedIcon />,
      text: "Promotions",
      onClick: handleClick,
      activeCondition: "promotion-visibility",
      active,
      disabled: isFreeTrial,
    },
    {
      subPath: "assortment",
      icon: <ShowChartOutlinedIcon />,
      text: "PPA & Assortment",
      onClick: handleClick,
      activeCondition: "assortment",  
      active,
      disabled: isFreeTrial,
    },
    {
      subPath: "potofolio-mix",
      icon: <DonutSmallIcon />,
      text: "Portfolio Mix",
      onClick: handleClick,
      activeCondition: "portofolio",
      active,
      disabled: true,
    },
    {
      subPath: "trade-management",
      icon: <SmsOutlinedIcon />,
      text: "Trade Management",
      onClick: handleClick,
      activeCondition: "trade",
      active,
      disabled: true,
    },
    {
      subPath: "brand-value",
      icon: <SettingsSuggestOutlined />,
      text: "Value Creation",
      onClick: handleClick,
      activeCondition: "brand",
      active,
      disabled: true,
    },
  ];
  // const DecisionCenter = [
  //   {
  //     subPath: "smart-simulator",
  //     icon: <SmartToyOutlinedIcon />,
  //     text: "Smart Market Simulator",
  //     onClick: handleClick,
  //     activeCondition: "smart-simulator",
  //     active,
  //     disabled: true,
  //   },
  //   {
  //     subPath: "optimization",
  //     icon: <AutoFixHighIcon />,
  //     text: "Optimization",
  //     onClick: handleClick,
  //     activeCondition: "optimization",
  //     active,
  //     disabled: true,
  //   },
  //   {
  //     subPath: "promo-simulator",
  //     icon: <LocalOfferOutlinedIcon />,
  //     text: "Promo Planner",
  //     onClick: handleClick,
  //     activeCondition: "promo-simulator",
  //     active,
  //     disabled: isFreeTrial ? true : false,
  //   },
  // ];

  // const DataCenterHub = [
  //   {
  //     subPath: "data-center-hub",
  //     icon: <StorageOutlinedIcon />,
  //     text: "Data Center Hub",
  //     onClick: handleClick,
  //     activeCondition: "data-center-hub",
  //     active,
  //     disabled: isFreeTrial ? true : false,
  //   },
  // ];

  return (
    <Stack direction="column" justifyContent="space-between">
      <List component="nav" aria-labelledby="nested-list-subheader">
        <div data-tour="market-overview">
          <CollapsibleList
            title="Market Overview"
            icon={<InsertChartOutlinedIcon />}
            items={MarketOverview}
            drawerOpen={open}
            setTitle={setTitle}
          />
        </div>
        <div data-tour="strategy-creation">
          <CollapsibleList
            title="Strategy Creation"
            icon={<CrisisAlertOutlinedIcon />}
            items={StrategyCreation}
            drawerOpen={open}
            setTitle={setTitle}
          />
        </div>
        {/* <CollapsibleList
          title="Data Center Hub"
          icon={<StorageOutlinedIcon />}
          items={DataCenterHub}
          drawerOpen={open}
          setTitle={setTitle}
        /> */}
      </List>

      {/* Canvas */}
        <ListItem disablePadding>
            <ListItemButton
              disabled={isFreeTrial}
              onClick={isFreeTrial ? undefined : () => handleClick("canvas", "canvas")}
              sx={{
                borderRadius: "20px",
                height: 36,
                px: 1.5,
                mb: 1,
                backgroundColor:
                  active === "canvas" ? theme.palette.primary.main : "transparent",
                color:
                  active === "canvas" ? "#fff" : theme.palette.primary.main,
                "&:hover": {
                  backgroundColor:
                    active === "canvas" ? theme.palette.primary.main : "#F5F5F5",
                },
              }}>
              <ListItemIcon sx={{
                minWidth: 0,
                mr: 1,
                color: active === "canvas" ? "#fff" : theme.palette.primary.main,
                ml: 2,
              }}>
                <BallotOutlinedIcon />
              </ListItemIcon>
              <ListItemText
                primary="Canvas"
                sx={{
                  color: active === "canvas" ? "#fff" : theme.palette.primary.main,
                  fontSize: "14px", 
                  fontWeight: "bold",
                }}
              />
            </ListItemButton>
          </ListItem>

        {/* SmartBot */}
          <ListItem disablePadding>
            <ListItemButton
              disabled={isFreeTrial}
              onClick={isFreeTrial ? undefined : () => handleClick("AI-Assistant", "SmartBot")}
              sx={{
                borderRadius: "20px",
                height: 36,
                backgroundColor:
                  active === "AI-Assistant" ? theme.palette.primary.main : "transparent",
                color:
                  active === "AI-Assistant" ? "#fff" : theme.palette.primary.main,
                "&:hover": {
                  backgroundColor:
                    active === "AI-Assistant" ? theme.palette.primary.main : "#F5F5F5",
                },
                p: 1, 
              }}>
              <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
                <Box
                  sx={{
                    minWidth: 0,
                    mr: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <img
                    src={active === "AI-Assistant" ? smartbot2Image : smartbot1Image}
                    alt="SmartBot"
                    style={{
                      width: 160,
                      height: 45,
                      objectFit: "contain",
                      display: "block",
                      transition: "all 0.3s ease-in-out",
                    }}
                  />
                </Box>
              </ListItemIcon>
              <ListItemText
                primary="SmartBot"
                sx={{
                  display: "none",
                }}
              />
            </ListItemButton>
          </ListItem>

        {/* Logout */}
      <ListItem disablePadding>
        <ListItemButton onClick={handleLogout}>
          <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
            <LogoutOutlinedIcon sx={{ color: theme.palette.primary.main }} />
          </ListItemIcon>

          <ListItemText
            sx={{
              color: theme.palette.primary.main,
              display: open ? "auto" : "none",
            }}
          >
            Sign Out
          </ListItemText>
        </ListItemButton>
      </ListItem>
    </Stack>
  );
}
